interface ErrorMessageProps {
  message: string;
  size?: 'sm' | 'xs';
}

export function ErrorMessage({ message, size = 'sm' }: ErrorMessageProps) {
  return (
    <p
      className={`border border-magenta/35 bg-magenta/8 px-[12px] py-[8px] text-magenta ${size === 'xs' ? 'text-xs' : 'text-sm'}`}
    >
      {message}
    </p>
  );
}
